import { observer } from 'mobx-react-lite'
import { CopyJobDialog } from '@/features/jobs/CopyJobDialog'
import { type CopyJobDialogViewModel } from './CopyJobDialogViewModel'

export interface CopyJobDialogContainerProps {
  vm: CopyJobDialogViewModel
}

export const CopyJobDialogContainer = observer(function CopyJobDialogContainer({
  vm,
}: CopyJobDialogContainerProps) {
  const testId = 'copy-job-modal'
  return (
    <CopyJobDialog
      showing={vm.modal.showing}
      onClose={vm.modal.close}
      onClone={vm.copyJob}
      isClonePending={vm.copyJob.pending}
      confirmButtonTestId={`${testId}-confirm`}
    />
  )
})
